import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { FondeadoresService } from '../services/fondeadores.service';
import { SocioFondeadorService } from '../services/socio-fondeador.service';
import { SucursalesService } from '../services/sucursales.service';
import { HelpersService } from '../services/tools/helpers.service';
import { EliminarFondeadorComponent } from '../administracion/fondeadores/eliminar-fondeador/eliminar-fondeador.component';
import { AumentarSaldoModalComponent } from './aumentar-saldo-modal/aumentar-saldo-modal.component';
import { EsquemaInversionModalComponent } from '../administracion/fondeadores/esquema-inversion-modal/esquema-inversion-modal.component';
import { RetirarSaldoModalComponent } from './retirar-saldo-modal/retirar-saldo-modal.component';

@Component({
  selector: 'app-modulo-vista',
  templateUrl: './modulo-vista.component.html',
  styleUrls: ['./modulo-vista.component.scss']
})
export class ModuloVistaComponent implements OnInit {

  //Variables
  public fondeadores : any[];
  public isUpdate: boolean = false;
  public fondeador : any = {};
  public isLoading: boolean = false;
  //Paginador
  public mostrarListado:boolean = true;
  public alterTable:any = 'starting';
  errors:any = {};
  searchProcess:any;
  paginate:any = {};
  filterBy:any;
  currentPage = 1;
  lastPage = 1;
  processing:any = false;

  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;
  searchText:string = "";
  searchSelected: any = {};
  selected:any;
  
  constructor(
    private fondeadoresService: FondeadoresService,
    private socioFondeadorService: SocioFondeadorService,
    private sucursalesService: SucursalesService,
    private helperService: HelpersService,
    private dialog: MatDialog,
    private router : Router
  ) { }

  ngOnInit() {
    this.getSociosFondeadores();
  }

  public registrarSocio(){
    //this.router.navigate(["registrar/socio-fondeador"]);
    this.router.navigate(["fondeadores/registro-fondeador"]);
  }

  public getSociosFondeadores(page?){
    let filters = this.getActiveFilters();
    console.log(filters);
    this.searchProcess = this.socioFondeadorService.obtenerSociosFondeadores(page, filters)
      .subscribe(response => {
        const content = response.json().content;
        this.fondeadores = content.data;
        console.log (response.json());
        console.log("Fondeadores: ", this.fondeadores);
        this.startPaginate(response.json().content);
        this.alterTable = (this.fondeadores.length > 0)? false: 'not_result';
      }, error => {
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }



  public goPerfilFondeador(id: number){
    this.router.navigate(['/perfil-socio/',id]);
  }

  public agregarEsquema(id: number){
    this.router.navigate(['/socio/registro-fondeador/',id]);
  }

  //Actualizar fondeador
  public actualizarFondeador(id: number){
    this.router.navigate(['/registrar/socio-fondeador/',id]);
  }

  //Delete gasto
  public eliminarFondeador(id: number){
    const dialogRef = this.dialog.open(EliminarFondeadorComponent, {
      height: '70vh',
      width: '20vw',
      data: {vistaSocio: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.eliminar){
        this.socioFondeadorService.delete(id).subscribe(
          (response) => {
            console.log(response);
            
            const respuesta = response.json();
            if (respuesta.success) {
              this.helperService.notification('Socio fondeador eliminado', 'Se ha borrado exitosamente', 'success');
              //Poner dentro del success response
              setTimeout(() => {this.getSociosFondeadores()},1000);
            }
          }, (error) =>{
            console.log(error);
            
            // if(error.status == 400) {
            //   this.showServicesErrors(error.json().content);
            // }else{
            //   this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            // }
            
            // // se resuelven los errores 403 y 500
            // this.helperService.httpGlobalError(error, false);
          }
        );
        // window.location.reload();
      }
    });
  }

  private getActiveFilters(){
    let filters:any = {
      page : null,
      search : null,
      paginate : true,
    };

    if(this.page){
      filters.page = this.page;
    }

    if(this.searchText){
      filters.search = this.searchText;
    }

    return filters;
  }

  public nuevoEsquema(id: number){
    const dialogRef = this.dialog.open(EsquemaInversionModalComponent, {
      height: 'auto',
      width: 'auto',
      data: {idFondeador: id}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.update){
        this.getSociosFondeadores();
      }
      this.isUpdate = false;
    });
  }

  public aumentarSaldo(id: number){
    const dialogRef = this.dialog.open(AumentarSaldoModalComponent, {
      height: 'auto',
      width: 'auto',
      data: {idSocio: id}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.aumento){
        this.getSociosFondeadores();
      }
    });
  }

  public retirarSaldo(id: number){
    const dialogRef = this.dialog.open(RetirarSaldoModalComponent, {
      height: 'auto',
      width: 'auto',
      data: {idSocio: id}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.retiro){
        this.getSociosFondeadores();
      }
    });
  }

  //Paginador
  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }
  
  filtrar(){
    this.goPage(1);
  }

  search(page = null){
    if (this.searchProcess){
      this.searchProcess.unsubscribe();
    }

    if (this.searchText.length > 1 || this.searchSelected.id != ''){
      if(this.searchSelected.id === undefined)
        this.searchSelected.id = '';
      this.searchProcess = this.fondeadoresService.search(this.searchText, page)
          .subscribe(
            response => {
            const content = response.json().content;
            this.fondeadores = content.data;
            this.startPaginate(content);
            this.searchProcess = false;
            this.alterTable = (this.fondeadores.length > 0)? false: 'not_found';
          }, error => {
            this.processing = false;

            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
              this.setBackendErrors(error.json().content);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          });
    } else {
      this.getSociosFondeadores();
    }
  }

  setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  startPaginate(content){
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for(let i = 1; i <= this.paginate.last_page; i++){
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage(){
    this.goPage(this.paginate.current_page - 1)
  }

  goNextPage(){
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {

    if (this.searchText) {
      this.search(page);
    } else {
      this.getSociosFondeadores(page);
    }

  }

  resetSelected(){
    this.selected = undefined;
    this.errors = {};
  }

  startSelected(){
    this.resetSelected();
    this.selected = this.fondeadoresService.getDefaultSchedule();
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }

  public agregarEstiloInactivo(index: number){
    if(!this.fondeadores[index].estatus){
      return "color-inactivo"
    }else{
      return "color-activo"
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modulo-vista/modulo-vista.component.ts